import { Icon } from '@veracity/vui'

interface Props {
  value: boolean
}
export const ScenarioComparisonBooleanIcon = ({ value }: Props) =>
  value ? (
    <Icon name="falCheck" pathFill="landGreen.41" />
  ) : (
    <Icon name="falTimes" pathFill="energyRed.54" />
  )
